export const environment = {
    apiUrl:'https://paygate-webhook-sandbox.sudoafrica.site/',
    jwtTokenEncryptionKey: 'Ajdie9384fdhfuhdueienAuSZ398D3xjaoeun9c8Mqmid302yQSiahfQ90183SAUDJD',
}